import { useEffect, useState } from "react";
import { useAdvanceSearchContext } from "../AdvanceSearchContextTest";
import Select from "../../../../components/Select";
import { InterviewService } from "../../../../services/InterviewService";

export default function AssignTo({ searchObject, onChange, t }) {
  const [managers, setManagers] = useState([]);

  useEffect(() => {
    InterviewService.GetManagerList().then((data) => setManagers(data));
  }, []);

  return (
    <div>
      <legend className="fontsize-legend">{t("Assign to")}</legend>{" "}
      <Select
        className="form-select fontsize-legend"
        name="assignToId"
        onChange={onChange}
        value={searchObject.assignToId || ""}
      >
        <option value=""></option>
        {managers.map((manager) => (
          <option className="fontsize-legend" value={manager.id}>
            {t(manager.nickname)}
          </option>
        ))}
      </Select>
    </div>
  );
}
